import axios from "axios";
import { SERVER_URL } from "../config/config";

class AdminUserService {
	private static serverURL = SERVER_URL;
	
	// private static  axiosConfig = {
	// 	headers: {
	// 		'Content-Type': 'application/json;charset=UTF-8',
	// 		"ApiKey": process.env.REACT_APP_API_KEY,
	// 		"SessionToken": sessionStorage.getItem("DsbaAdminToken")
	// 	}
	//   };

	public static getStatus() {
		const apiUrl = `${this.serverURL}/status`;
		const response = axios.get(apiUrl);
		return response;
	}
	public static async userLogin(email: string, password: string) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/login`;
		const response = await axios.post(apiUrl, {
			Email: email,
			Password: password,
		}, axiosConfig);
		//console.log("response", response);
		return response;
	}
	

	public static async userSignUpConfirmation(securedString: string, password: string) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/confirm-registration`;
		const response = await axios.post(apiUrl, {
			RandomString: securedString,
			Password:password
		}, axiosConfig);
		return response;
	}
	
	public static async forGotPasswordSendLink(email: string) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/forgot-password`;
		const response = await axios.post(apiUrl, {
			Email: email,
		}, axiosConfig);
		return response;
	}

	public static async forGotPasswordResetPassword(securedString: string, password: string, ) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/forgot-password/change-password`;
		const response = await axios.post(apiUrl, {
			Password: password,
			RandomString: securedString,
		}, axiosConfig);
		return response;
	}

	
	public static async getAdminList() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		// console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"))
		const apiUrl = `${this.serverURL}/api/admin`;
		const response = await axios.get(apiUrl, axiosConfig);
		//console.log("response", response);
		return response;
	}

	public static async deleteAdminUser(userId: number) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		// console.log("DsbaAdminToken 11:", sessionStorage.getItem("DsbaAdminToken"))
		const apiUrl = `${this.serverURL}/api/admin/${userId}`;
		const response = await axios.delete(apiUrl, axiosConfig);
		//console.log("response", response);
		return response;
	}



	public static async getMemberType() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-type`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}
	public static async addMemberType(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-type`;
		const response = await axios.post(apiUrl,body, axiosConfig);
		return response;
	}

	public static async updateMemberType(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-type`;
		const response = await axios.put(apiUrl,body, axiosConfig);
		return response;
	}

	public static async getMemberCode() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-code`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addMemberCode(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-code`;
		const response = await axios.post(apiUrl,body, axiosConfig);
		return response;
	}

	public static async updateMemberCode(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-code`;
		const response = await axios.put(apiUrl,body, axiosConfig);
		return response;
	}

	public static async getMemberSection() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-section`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addMemberSection(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-section`;
		const response = await axios.post(apiUrl,body,axiosConfig);
		return response;
	}

	public static async updateMemberSection(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-section`;
		const response = await axios.put(apiUrl,body,axiosConfig);
		return response;
	}

	public static async getMemberTag() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-tag`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addMemberTag(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-tag`;
		const response = await axios.post(apiUrl,body,axiosConfig);
		return response;
	}

	public static async updateMemberTag(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/member-tag`;
		const response = await axios.put(apiUrl,body,axiosConfig);
		return response;
	}

	public static async createAdminUser(body: any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin`;
		const response = await axios.post(apiUrl, 
		body, axiosConfig);
		return response;
	}

	public static async updateAdminUser(body: any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/`+body.Id;
		const response = await axios.put(apiUrl, 
		body, axiosConfig);
		return response;
	}

	public static async getMyInfo() {
		const apiUrl = `${this.serverURL}/user`;
		const token = sessionStorage.getItem("DsbaAdminToken");
		console.log("token:", token);
		const config = {
			headers: { Authorization: `Bearer ${token}` },
		};
		try {
			const response = await axios.get(apiUrl, config);
			return response;
		} catch (err) {
			// const axiosError = err as AxiosError;
			// handleError(axiosError);
			// return err;
		}
		// return response;
	}

	public static async getFirm(parameteres:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			},
			params: parameteres,
		  };
		const apiUrl = `${this.serverURL}/api/firm`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addFirm(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/firm`;
		const response = await axios.post(apiUrl,body,axiosConfig);
		return response;
	}

	public static async updateFirm(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/firm`;
		const response = await axios.put(apiUrl,body,axiosConfig);
		return response;
	}

	public static async getAdminRole() {
		console.log(sessionStorage.getItem("DsbaAdminToken"),'*******************')
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		  console.log(axiosConfig)
		const apiUrl = `${this.serverURL}/api/admin/role`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async getLocation() {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			},
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-location`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addLocation(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-location`;
		const response = await axios.post(apiUrl,body,axiosConfig);
		return response;
	}

	public static async updateLocation(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-location`;
		const response = await axios.put(apiUrl,body,axiosConfig);
		return response;
	}

	public static async getCost() {
		let axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			},
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-cost`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}

	public static async addCost(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-cost`;
		const response = await axios.post(apiUrl,body,axiosConfig);
		return response;
	}
	public static async updateCost(body:any) {
		let   axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			}
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-cost`;
		const response = await axios.put(apiUrl,body,axiosConfig);
		return response;
	}

	public static async getHelpVideos() {
		let axiosConfig = {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				"ApiKey": process.env.REACT_APP_API_KEY,
				"SessionToken": sessionStorage.getItem("DsbaAdminToken")
			},
		  };
		const apiUrl = `${this.serverURL}/api/admin/config-helpvideos`;
		const response = await axios.get(apiUrl, axiosConfig);
		return response;
	}
}

export default AdminUserService;

// axios.interceptors.response.use(
// 	(res) => {
// 		return res;
// 	},
// 	(err) => {
// 		if (err.response.data.error.errorCode == 401) {
// 			console.log("unauth erro");
// 			console.log("loc", window.location.pathname);
// 			sessionStorage.removeItem("DsbaAdminToken");
// 			alert("Token Expired Please Login again");
// 			// let html = <h1>hello </h1>
// 			window.location.href = "/sign-in/?path=" + window.location.pathname; //working
// 		}
// 		return Promise.reject(err);
// 	}
// );
